import userfeelback from "./userfeelback.js";
import userback from "./userback.js";

export default {
  userfeelback,
  userback,
};
